import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { getFilesFromEvent, isTextPasteEvent } from './utils/event';
import { byExtension } from './utils/file';

interface FileDropOptions {
	allowedExtensions: null | string[];
	onDrop: (file: File) => void;
}

export const FileDrop = Extension.create<FileDropOptions>({
	name: 'FileDrop',

	addOptions() {
		return {
			allowedExtensions: null,
			onDrop: () => void 0,
		};
	},

	addProseMirrorPlugins() {
		const extensions = this.options.allowedExtensions;

		return [
			new Plugin({
				key: new PluginKey('FileDrop'),

				props: {
					handleDOMEvents: {
						drop: (_view, e) => {
							if (!e || isTextPasteEvent(e as any)) {
								return;
							}

							if (e.cancelable) {
								e.preventDefault();
							}

							const files = getFilesFromEvent(e);

							if (!files || !files.length) {
								return;
							}

							const file = (extensions ? [...files].filter(byExtension(extensions)) : files)[0];

							if (file && this.options.onDrop) {
								this.options.onDrop(file);
							}
						},
					},
				},
			}),
		];
	},
});
